<template>
  <div class="feedback">
    <md-dialog
      id="modDashboardComponents"
      ref="feedback"
      md-title
      :md-esc-to-close="false"
      :md-click-outside-to-close="false"
      class="feedback-survey modals"
    >
      <md-dialog-title>
        <button
          id="mod_btnClose"
          class="close-button btn-transparent"
          @click="closeFeedbackModal"
        >
          <md-icon>clear</md-icon>
        </button>
      </md-dialog-title>
      <md-dialog-content>
        <component :is="feedbackCurrentView" />
      </md-dialog-content>
    </md-dialog>
  </div>
</template>

<script>
import fullSystem from './FullSystemStep'
import mixin from './feedbackMixin'
export default {
  components: {
    'full-system': fullSystem
  },
  mixins: [mixin],
  watch: {
    isFeedbackModalVisible () {
      if (this.isFeedbackModalVisible) {
        this.$refs.feedback.open()
      } else {
        this.$refs.feedback.close()
      }
    }
  }
}
</script>

<style lang="scss">
  .feedback-survey {
    .md-dialog-content {
      margin: 0 10px 4px 10px;
    }
  }
</style>
